import { configureStore } from '@reduxjs/toolkit';
import { sessionSlice } from '../features/login/session.slice';
import { dashboardTeamSlice } from '../features/dashboard/team/dashboard-team.slice';
import { dashboardProfileSlice } from '../features/dashboard/profile/dashboard-profile.slice';
import { dashboardPaymentSlice } from '../features/dashboard/payments/dashboard-payment.slice';
import { configurationSlice } from '../features/configuration/configuration.slice';
import { dashboardSettingsSlice } from '../features/dashboard/settings/dashboard-settings.slice';
import { dashboardDiscountSlice } from '../features/dashboard/discount/dashboard-discount.slice';
import { dashboardPlanSlice } from '../features/dashboard/payments/dashboard-plan.slice';
import { dashboardChallengesSlice } from '../features/dashboard/challenges/dashboard-challenges.slice';

export const store = configureStore({
  reducer: {
    session: sessionSlice.reducer,
    dashboardTeam: dashboardTeamSlice.reducer,
    dashboardDiscounts: dashboardDiscountSlice.reducer,
    dashboardProfile: dashboardProfileSlice.reducer,
    dashboardPayment: dashboardPaymentSlice.reducer,
    dashboardPlan: dashboardPlanSlice.reducer,
    dashboardChallenges: dashboardChallengesSlice.reducer,
    dashboardSettings: dashboardSettingsSlice.reducer,
    configuration: configurationSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
});
